module.exports = __webpack_public_path__ + "static/media/vinnie-4row.1451866d.png";